import { call } from '../utils/api';
import { DateTime } from 'luxon';

class ReportsService {
  fetchReports(startDate = null, endDate = null) {
    if (endDate === null) {
      const now = DateTime.local();
      endDate = now.minus({ day: 1 }).toFormat('yyyy-MM-dd');
      startDate = now.minus({ week: 1 }).toFormat('yyyy-MM-dd');
    }

    return Promise.all([
      call('report/analytics', 'POST', { startDate, endDate }),
      call('report/revenue', 'POST', { startDate, endDate })
    ]);
  }
}

export const reportsService = new ReportsService();



// WEBPACK FOOTER //
// ./src/services/reportsService.js